import { NO_EVENTS } from "@constants/global";
import SVG from "components/SVG";
import useTranslation from "next-translate/useTranslation";

const NoEventCard = () => {
  const { t } = useTranslation("common");
  return (
    <div
      className="m-0 flex h-full w-full flex-col items-center justify-center p-0"
      style={{
        height: "380px",
        width: "100%",
      }}
    >
      <SVG src={NO_EVENTS} width={268} height={288} />
      <h4
        className="text-md mt-3 text-center font-normal"
        style={{ lineHeight: "normal" }}
      >
        {t("No tienes eventos")}
        <br />
        {t("agendados todavía")}
      </h4>
    </div>
  );
};

export default NoEventCard;
